import React from 'react'

export const money = (n: number) => '€' + (Number(n) || 0).toFixed(2)

export const fmtDate = (dt: string) =>
  new Date(dt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })

export const fmtDateTime = (dt: string) =>
  new Date(dt).toLocaleString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  })

export const monthName = (monthId: string) =>
  new Date(monthId + '-01T00:00').toLocaleString('en', { month: 'long', year: 'numeric' })

// Current time as a value for <input type="datetime-local">, in the user's
// local timezone. (new Date().toISOString() alone would give UTC wall time —
// 1-2h off for Vienna, putting receipts added after midnight on the 1st into
// the previous month.)
export const nowLocalInput = (): string => {
  const d = new Date()
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
  return d.toISOString().slice(0, 16)
}

// Convert an ISO-ish datetime string to a value usable by <input type="datetime-local">.
// Backend strings carry the app timezone's wall time, so slicing keeps it; a
// naive string sent back is interpreted in that same timezone — round-trip safe.
export const toLocalInput = (dt: string): string => {
  if (!dt) return ''
  if (dt.includes('T') && dt.length >= 16) return dt.slice(0, 16)
  const d = new Date(dt)
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
  return d.toISOString().slice(0, 16)
}

// First / last day of a "YYYY-MM" month, as getReceipts({start_date,end_date}) params
export const monthRange = (monthId: string) => {
  const [y, m] = monthId.split('-').map(Number)
  const last = new Date(y, m, 0).getDate()
  return {
    start_date: `${monthId}-01T00:00:00`,
    end_date: `${monthId}-${String(last).padStart(2, '0')}T23:59:59`,
  }
}

export const PayerPill: React.FC<{ payer: string }> = ({ payer }) => (
  <span className={`pill pill-${payer === 'David' ? 'david' : 'timna'}`}>{payer}</span>
)

export const Avatar: React.FC<{ who: string }> = ({ who }) => (
  <div className={`avatar ${who === 'David' ? 'av-david' : 'av-timna'}`}>{who.charAt(0)}</div>
)

export const Spinner: React.FC = () => <span className="spinner" role="status" aria-label="Loading" />
